import React from 'react';

import CategoriaModelos from 'components/Windx/ControlPanel/Models/CategoriaModelos';
import { agruparPorCategoria } from 'components/Windx/ControlPanel/Models';
import { Modelo, modeloElegivel, TipoRodada } from 'helper/windx';

interface ModelosProps {
  modelos: Modelo[];
  idsSelecionados: number[];
  onChange: (ids: number[]) => void;
  idsIndisponiveis?: number[];
  datasRodadaPorId?: Record<number, string>;
  tipoRodada?: TipoRodada;
  modoSelecao?: 'checkbox' | 'radio';
}

/**
 * Corpo da secao "Modelos" do painel mobile.
 *
 * REUSA o `CategoriaModelos` do desktop em vez de reconstruir com `OptionRow`:
 * ele nao e um `Accordion.Item` (e um <div> autonomo), entao cabe dentro do
 * `Section` do BottomSheet. Com isso o mobile herda de graca o agrupamento
 * (WINDX-048), o contador por grupo, os botoes Todos/Nenhum, a data de rodada
 * formatada (ADR-018) e os sufixos "(sem dados)" / "(so preliminar|final)".
 *
 * A unica logica daqui e a dos dois handlers de grupo — espelho dos que o
 * `Models` desktop passa —, e a elegibilidade vem de `modeloElegivel`, a
 * definicao unica em `helper/windx`.
 */
export default function Modelos({
  modelos,
  idsSelecionados,
  onChange,
  idsIndisponiveis,
  datasRodadaPorId,
  tipoRodada,
  modoSelecao = 'checkbox',
}: ModelosProps) {
  const indisponiveisSet = new Set(idsIndisponiveis ?? []);

  const selecionarTodosDoGrupo = (modelosDoGrupo: Modelo[]) => {
    const idsElegiveis = modelosDoGrupo
      .filter((m) => modeloElegivel(m, indisponiveisSet, tipoRodada))
      .map((m) => m.id);
    onChange(Array.from(new Set([...idsSelecionados, ...idsElegiveis])));
  };

  const limparGrupo = (modelosDoGrupo: Modelo[]) => {
    const idsDoGrupo = new Set(modelosDoGrupo.map((m) => m.id));
    onChange(idsSelecionados.filter((id) => !idsDoGrupo.has(id)));
  };

  return (
    <>
      {agruparPorCategoria(modelos).map((grupo) => (
        <CategoriaModelos
          key={grupo.chave}
          chave={grupo.chave}
          titulo={grupo.label}
          modelos={grupo.modelos}
          idsSelecionados={idsSelecionados}
          idsIndisponiveis={indisponiveisSet}
          datasRodadaPorId={datasRodadaPorId}
          tipoRodada={tipoRodada}
          modoSelecao={modoSelecao}
          defaultOpen
          onChange={onChange}
          onSelecionarTodos={selecionarTodosDoGrupo}
          onLimpar={limparGrupo}
        />
      ))}
    </>
  );
}
